import { GET_MAINTENANCE_SCHEDULES_CONFIG_URL, getMaintenanceSchedulesConfig } from "src/clients";
import { useTranslate } from "src/hooks";
import useSWR from "swr";

export const useMessageMaintenance = () => {
  const { getTranslation } = useTranslate();
  const { data } = useSWR([GET_MAINTENANCE_SCHEDULES_CONFIG_URL], () => 
    getMaintenanceSchedulesConfig().then(res => res.data.data));

  const subject = 'Bank/E-Wallet Maintenance Information';
  const emailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${getTranslation('common_email_partner_helpdesk')}&su=${encodeURIComponent(subject)}`;

  return {
    data,
    emailLink,
    getTranslation,
  }
}
